export default {
  ERROR_PACKAGE_SIZE: 'Error Package Size',
  ERROR_QUANTITY: 'Error Quantity',
  LABEL_ERROR: 'Label Error',
  NDC_CHANGE: 'Ndc Change',
  OUT_OF_STOCK: 'Out Of Stock',
};
